
import React from 'react';
import PropTypes from 'prop-types';

var NavLink = function NavLink(_ref) {
    var children = _ref.children;

    return React.createElement(
        'div',
        { className: 'top-navigation-nav-link d-inline-flex justify-content-center align-items-center' },
        children,
        React.createElement('div', { className: 'nav-link-border-bottom' })
    );
};

NavLink.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
    * children : React router dom navlink
    */
    children: PropTypes.element

} : {};
export default NavLink;